import React, { useEffect, useState, useRef, useMemo } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import "../../App.css";
import { CircularProgress, Grid, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Notification from "../../components/NotificationComponent";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { LISTING_GENERIC_HEADER } from "./ColumnHeader";
import { getRowDataLab, getAllLabTestsByCategoryId } from "../../services/LabService";
import "./../GridItem/AgGrid.css";
import GridItem from "../GridItem/GridItem";
import { MAIN_BLUE } from "../../color";
import { PAGE_SIZE_ARRAY } from "../../constants";
import DeletableChips from "../../components/Chips/DeletableChips";
import SimpleDialogDemo from "../../components/Filter/FilterPopup";
import { useParams } from "react-router-dom";
import FilterButton from "../../components/CommonFilterCreateButton/FilterButton";
import SearchBar from "../../components/CommonSearchBar/Search";
import KeycloakService from "../../services/KeycloakService";
import { useAppSelector } from "../../services/StoreHooks";
import useTranslatewrapper from "../../components/useTranslateWrapper";
const PremixLabGrid = (props) => {

  const {translate} = useTranslatewrapper();

  const categoryNameToIdSelectorRedux = useAppSelector((state) =>
    state?.categoriesData?.categories
  );
  
  const categoryMapping = useMemo(()=>{
    return (
      categoryNameToIdSelectorRedux.reduce(
      (acc, current) => {
        acc[current.id.toString()] = current.name;
        return acc;
      },
      {}
    ))
  }, [categoryNameToIdSelectorRedux])


  const routeParams = useParams();
  const currentGridLocation = useLocation();
  const pathNameCapitalize = useLocation().pathname.split("/")[1];

  //  localStorage.setItem("current-page-path", currentGridLocation.pathname);
  localStorage.setItem(
    "current-page-path",
    `/${pathNameCapitalize}/${routeParams.categoryId}`
  );
  const isSuperAdmin = KeycloakService.getUserDetail()?.role?.includes("SUPER");
  const [loader, setLoader] = React.useState(false);
  const [gridApi, setGridApi] = useState(null);
  const [columnDefs, setColumnDefs] = React.useState(LISTING_GENERIC_HEADER(categoryMapping, translate));
  const gridRef = useRef();
  const [rowData, setRowData] = useState([]);
  const [pageSize, setPageSize] = React.useState(12);
  const [pageNo, setPageNo] = React.useState(1);
  const [count, setCount] = React.useState(1);
  const [selected, setSelected] = React.useState([]);
  const [options, setOptions] = React.useState([]);
  const navigate = useNavigate();
  const [filterData, setFilterData] = React.useState({
    searchCriteriaList: [],
    state: [],
    receivedStartDate: "",
    receivedEndDate: "",
    sampleSentEndDate: "",
    sampleSentStartDate: "",
  });
  const dispatch = useDispatch();
  const [chip, setChip] = useState("");
  const [clear, setclear] = useState(false);
  const [chipsState, setChipsState] = React.useState({});
  const [filterStates, setFilterStates] = React.useState([]);

  const [openFilter, setOpenFilter] = React.useState(false);
  const [activeFilters, setActiveFilters] = React.useState({});
  const filterDataRedux = useSelector((state) => state.filterData);
  const handleSelectChange = (values) => {
    setSelected(values);
  };
  const handleClickOpen = () => {
    setOpenFilter(true);
  };
  const handleClose = () => {
    setOpenFilter(false);
  };

  useEffect(() => {
    getRowData(pageNo, pageSize);
    updateChips();
  }, [filterDataRedux]);

  const getRowData = async (pageNo, pageSize) => {
    let fetchRowData;
    if(isSuperAdmin){
     fetchRowData = await getAllLabTestsByCategoryId(filterDataRedux, pageNo, pageSize);
    }else{
      if(filterDataRedux.searchCriteriaList[4].value){
        fetchRowData = await getRowDataLab(filterDataRedux, pageNo, pageSize);

      }
    }

    if(fetchRowData?.data?.data) {
      setCount(fetchRowData?.data?.count);
      setRowData(fetchRowData?.data?.data);
    }
  };
  let chipMap = {};
  const updateChips = () => {
    filterDataRedux.searchCriteriaList.map((entry) => {
      switch (entry.key) {
        case "batchNo":
          if (entry.value) chipMap["batchNo"] = entry.value;
          // code block
          break;
        case "sampleSentDate":
          if (entry.value !== "" && entry.value)
            chipMap["sampleSentDate"] = entry.value;
          break;
        case "receivedDate":
          if (entry.value !== "" && entry.value)
            chipMap["receivedDate"] = entry.value;
          break;
        case "stateIds":
          if (entry.value !== "" && entry.value)
            chipMap["stateIds"] = entry.value;
          break;
      }
    });
    setChipsState(chipMap);
  };

  useEffect(() => {
    var json = filterDataRedux.searchCriteriaList;
    var json1 = structuredClone(json);
    if (routeParams.categoryId) {
      json1[4].value = String(routeParams.categoryId);
    }
    dispatch({
      type: "UPDATE_FILTER",
      data: json1,
    });
  }, []);

  const deleteChip = (chipKey, chipValue) => {
    var json = filterDataRedux.searchCriteriaList;
    var json1 = structuredClone(json);

    if (chipKey === "batchNo") {
      json1[0].value = "";
    }
    if (chipKey === "sampleSentDate") {
      setFilterData({ ...filterData, sampleSentStartDate: "", sampleSentEndDate: "" });

      json1[1].value = "";
    }
    if (chipKey === "receivedDate") {
      setFilterData({ ...filterData, receivedStartDate: "", receivedEndDate: "" });

      json1[2].value = "";
    }
    if (chipKey === "stateIds") {
      const index = json1[3].value.indexOf(chipValue);
      if (index > -1) {
        json1[3].value.splice(index, 1);
      }
      setFilterStates(json1[3].value);
    }

    if (json1[3].value.length == 0) json1[3].value = [null];

    dispatch({
      type: "UPDATE_FILTER",
      data: json1,
    });
  };

  const setPage = (page) => {
    setPageNo(page);
    getRowData(page, pageSize);
  };
  const counter = () => {
    return count % pageSize === 0
      ? Math.floor(count / pageSize)
      : Math.floor(count / pageSize) + 1;
  };
  const setFilters = (filterData) => {
    // var json = filterDataRedux.searchCriteriaList;
    // var json1 = structuredClone(json);
    // //
    // if (filterStates.length != 0) {
    //   setFilterData({ ...filterData, state: filterStates });
    //   json1[3].value  = filterStates
    //   //
    // }
    // else{
    //   json1[3].value  = [null]
    // }
    // json1[0].value = searchValue;
    // json1[1].value = `${dateValue(filterData.mnfStartDate)}${"-"}${dateValue(
    //   filterData.mnfEndDate
    // )}`;
    // json1[2].value = `${dateValue(filterData.expStartDate)}${"-"}${dateValue(
    //   filterData.expEndDate
    // )}`;
    // dispatch({
    //   type: "UPDATE_FILTER",
    //   data: json1,
    // });
  };

  const onGridReady = (params) => {
    setGridApi(params);
  };
  const onRowClicked = (params) => {
    const selectedRows = gridRef.current.api.getSelectedRows();

    const detailsPath = localStorage.getItem("current-page-path");
    navigate(`${detailsPath}/details/${selectedRows[0].id}`);
  };
  const location = useLocation();
  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const pathName = location.pathname.split("/").filter((x) => x);

  const RowSelectionType = "single";
  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      minWidth: 170,
      maxWidth: 250,
      floatingFilter: false,
      resizable: true,
    };
  }, []);
  const setFiltersSearch = (data) => {
    var json = filterDataRedux.searchCriteriaList;
    var json1 = structuredClone(json);
    if (data == null) {
      json1[0].value = "";
    } else {
      json1[0].value = data.label;
      setChip(data.label);
    }
    dispatch({
      type: "UPDATE_FILTER",
      data: json1,
    });
  };

  const removeSearch = (data) => {
    var json = filterDataRedux.searchCriteriaList;
    var json1 = structuredClone(json);
    if (data != null) {
      json1[0].value = "";
      setChip("");
      setclear(true);
    }
    dispatch({
      type: "UPDATE_FILTER",
      data: json1,
    });
  };
  return (
    <div>
      {loader ? (
        <Stack alignItems="center" mt={5}>
          <CircularProgress />
        </Stack>
      ) : (
        <div>
          <Box className="main-content-overlay">
            <div className="main-content-div">
              <Box m={2}>
                <Grid container>
                  <Grid item md={3} sd={12} p={1}>
                    <Typography variant="h6" sx={{ color: MAIN_BLUE, mx: 1 }}>
                      {`${capitalize(translate(pathName[0].replace('miller','Miller(FR)')))} ${translate('samples')}`}
                    </Typography>
                  </Grid>
                  <Grid item md={5}>
                    <Stack direction="row" sx={{ my: 1.5 ,flexWrap: "wrap" }}>
                      {Object.keys(chipsState)?.map((key) => (
                        <DeletableChips
                          chipValue={chipsState[key]}
                          chipKey={key}
                          deleteChip={deleteChip}
                          options={options}
                          sx={{ maxHeight: "2rem !important" }}
                        />
                      ))}
                    </Stack>
                  </Grid>
                  <Grid item md={4} sx={{display: 'flex', alignItems: 'center'}}>
                    <SearchBar
                      onChange={(e) => {
                        if (e !== "") {
                          setFiltersSearch(e);
                        } else {
                          removeSearch();
                        }
                      }}
                    />
                    {openFilter ? (
                      <div>
                        <SimpleDialogDemo
                          chipsState={chipsState}
                          open={openFilter}
                          onClose={handleClose}
                          filterData={filterData}
                          setFilterData={setFilterData}
                          setFilters={setFilters}
                          selected={selected}
                          setSelected={setSelected}
                          setActiveFilters={setActiveFilters}
                          activeFilters={activeFilters}
                          handleSelectChange={handleSelectChange}
                        />
                      </div>
                    ) : (
                      <FilterButton handleClickOpen={handleClickOpen} />
                    )}
                  </Grid>
                </Grid>

                <Box sx={{ m: 1 }}>
                  <GridItem
                    onGridReady={onGridReady}
                    rowData={rowData}
                    gridRef={gridRef}
                    rowSelection={RowSelectionType}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    pageSize={pageSize}
                    pageSizeArray={PAGE_SIZE_ARRAY}
                    count={counter()}
                    setPage={setPage}
                    page={pageNo}
                    onSelectionChanged={onRowClicked}
                  />
                </Box>
              </Box>
            </div>
          </Box>
        </div>
      )}
    </div>
  );
};

export default PremixLabGrid;
